import { render, staticRenderFns } from "./LongWork.vue?vue&type=template&id=66cde0b6&scoped=true"
import script from "./LongWork.vue?vue&type=script&lang=js"
export * from "./LongWork.vue?vue&type=script&lang=js"
import style0 from "./LongWork.vue?vue&type=style&index=0&id=66cde0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cde0b6",
  null
  
)

export default component.exports